<ng-container *transloco="let t">
  <div class="d-flex flex-column">
    <div class="race-grid-item" [class.is-last]="isLast">
      <app-races-header [race]="race"></app-races-header>
      <div class="race-grid-item--body">
        <div class="item-info d-flex justify-content-between align-items-center">
          <div class="w-100-sm-auto-xxl">
            <p class="race-grid-item__title trim-text">
              <app-language-output
                [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                [siLabel]="race?.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
            </p>
            <div>
              <p class="mb-2 mb-md-3 fw-semibold color-primary">{{
                  race && race.raceStart ? (race!.raceStart |
                      localizedDate:'short')
                    : '-'
                }}</p>
            </div>
            <div class="race-details mb-2 mb-md-3 ">
              <div class="race-details__item">
                <div class="race-details__content">
                  <div class="fw-semibold">{{ t("race.details.registration.until") }}</div>
                  <div> {{
                      race
                        ? (race.registrationEnd | localizedDate:'short')
                        : '-'
                    }}
                  </div>
                </div>
              </div>
              <div class="race-details__item">
                <div class="race-details__content">
                  <div class="fw-semibold"> {{ t("event.item.participants") }}</div>
                  <div> {{
                      race | raceCompetitorCountFormat
                    }}
                  </div>
                </div>
              </div>
              <div class="race-details__item">
                <div class="race-details__content">
                  <div class="fw-semibold"> {{ t("race.grid.elevation") }}</div>
                  <div>
                    {{ race | raceAltitudeFormat }}
                  </div>
                </div>
              </div>
            </div>
            <div class="fw-semibold">
              {{ t("race.details.price.from") }}: <span class="color-primary">{{
                race
                  ? (raceCommercialItems | raceCommercialItemsMinPriceFormat:currencyLabel)
                  : '-'
              }}</span>
            </div>
          </div>
          <div class="race-grid-item__cta-container d-flex flex-nowrap">
            <app-rounded-button [label]="t('race.details.more.details')"
                                [btnClass]="'rounded-button--black-outline'"
                                (onClick)="onMore()"/>
            <div class="btn-horizontal-spacer"></div>
            <app-rounded-button [label]="t('race.grid.register')" [btnClass]="'rounded-button--solid'"
                                (onClick)="onRegister()"
                                [isDisabled]="!race?.raceRegistrationEnabled"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
